import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '@core/services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si erreur 403 (accès interdit)
      if (error.status === 403) {
        // Extraire le message d'erreur si disponible
        const message =
          error.error?.apierror?.message ||
          error.error?.message ||
          "Vous n'avez pas les droits pour effectuer cette action.";

        toastService.error(message, 'Accès refusé');

        // Rediriger vers la page d'accès refusé au lieu de l'accueil
        router.navigate(['/error/forbidden']);
      }

      // Si erreur 404 (non trouvé)
      if (error.status === 404) {
        // Ne pas afficher de toast pour les erreurs 404 (peut être normal)
        console.warn(`Resource not found: ${req.url}`);
      }

      // Si erreur 500 (erreur serveur)
      if (error.status >= 500) {
        toastService.error(
          "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
          'Erreur serveur',
        );
      }

      return throwError(() => error);
    }),
  );
};
